// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BadgeIcon_wrapper__vQla_","description":"BadgeIcon_description__aCL0n"};